var map = {
	"./EmailLogo.svg": "8538",
	"./burger.svg": "2e69",
	"./certificate.png": "f2f2",
	"./certificateZoom.png": "32c0",
	"./circles.svg": "7a25",
	"./down.svg": "bf81",
	"./face.png": "379d",
	"./flowers.jpg": "7671",
	"./githubLogo.svg": "0fae",
	"./linkedinLogo.svg": "3217",
	"./loveLogo.svg": "acdf",
	"./screenshotComingSoon.jpg": "91c8",
	"./screenshotMusicApp.jpg": "7718",
	"./screenshotSlotGame.jpg": "38d5",
	"./skillsChart.svg": "27dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";